module.exports = __webpack_public_path__ + "img/bg-image-9.0d2d668d.jpg";